import { render, staticRenderFns } from "./GridColumns.vue?vue&type=template&id=5af79ea8&scoped=true&"
import script from "./GridColumns.vue?vue&type=script&lang=js&"
export * from "./GridColumns.vue?vue&type=script&lang=js&"
import style0 from "./GridColumns.vue?vue&type=style&index=0&id=5af79ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af79ea8",
  null
  
)

export default component.exports